var render = function render(){var _vm=this,_c=_vm._self._c;return _c('information-panel',{staticClass:"has-margin-top",attrs:{"title":"状态信息","loading":_vm.loading,"columns":_vm.columns,"card-bordered":true,"data-source":_vm.statusInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }